// extracted by css-extract-rspack-plugin
export default {"ChipLabel":"Chip-module__ChipLabel___BfuiA","ChipIconWrapper":"Chip-module__ChipIconWrapper___c1mXw","ChipInput":"Chip-module__ChipInput___kglJY"};